export const settlementTableListSelector = (state) =>
  state.settlementReducer?.settlementTableList;
export const settlementDataByIDSelector = (state) =>
  state.settlementReducer?.settlementDataByID;
export const settlementSearchDataSelector = (state) =>
  state.settlementReducer?.settlementSearchData;
